module.exports = __webpack_public_path__ + "img/service-power.49e241a3.jpg";